<template>
  <v-container>
    <v-tabs
      v-model="tabIndex"
      slider-color="secondary"
      color="primary"
      background-color="transparent"
      active-class="secondary"
    >
      <v-tab
        v-for="(tab, index) in tabs"
        :key="'tab' + index"
      >
        <v-icon left>{{tab.icon}}</v-icon>
        {{tab.title}}
      </v-tab>
    </v-tabs>
    <v-fade-transition mode="out-in">
      <component :is="tabs[tabIndex].component" :key="'component' + tabIndex"/>
    </v-fade-transition>
  </v-container>
</template>

<script>
import BrandsList from '@/components/Brand/BrandsList'
import BrandsCalendar from '@/components/Brand/BrandsCalendar'
export default {
  components: { BrandsList, BrandsCalendar },
  data: () => ({
    tabIndex: 0,
  }),
  computed: {
    tabs () {
      return [
        {title: 'Liste des enseignes', icon: 'list', component: BrandsList},
        {title: 'Calendrier des fermetures', icon: 'event_busy', component: BrandsCalendar}
      ]

    }
  }

}
</script>
